module.exports = __webpack_public_path__ + "3f48ca1dd0d559495a2dd51dc6616369.svg";